import { Button } from "@/core/components/ui/button";
import { Card } from "@/core/components/ui/card";
import { CarouselItem } from "@/core/components/ui/carousel";
import { cn } from "@/core/utils";

interface CarouselInsightsItemProps {
  icon: React.ReactNode;
  tag?: string;
  content: React.ReactNode;
  emptyContent?: string;
  buttonText: string;
  cardPadding?: string;
  color: {
    cardBackground?: string;
    iconBackground: string;
    iconText: string;
    buttonBackground?: string;
    buttonBorder?: string;
    buttonText?: string;
    buttonBorderHover?: string;
    buttonBackgroundHover?: string;
    buttonTextHover?: string;
  };
  onClick: () => void;
}

export function CarouselInsightsItem({
  icon,
  tag,
  content,
  emptyContent,
  buttonText,
  color,
  cardPadding,
  onClick,
}: CarouselInsightsItemProps) {
  return (
    <CarouselItem className="basis-2/3 min-w-[280px] max-w-full">
      <Card
        className={cn(
          "border border-[#e2e8f0] rounded-2xl shadow-none min-h-[150px] h-full p-4",
          cardPadding && `${cardPadding}`,
          color.cardBackground && `bg-${color.cardBackground}`,
        )}
      >
        <div className="flex gap-2 h-full">
          <div
            className={cn(
              "flex justify-center items-center w-10 h-10 rounded-full text-muted-foreground [&>svg]:w-6 [&>svg]:h-6",
              `bg-${color.iconBackground}`,
              `text-${color.iconText}`,
            )}
          >
            {icon}
          </div>

          <div className="flex flex-col">
            {tag && (
              <p className="mb-2 text-sm font-regular text-muted-foreground">
                {tag}
              </p>
            )}

            {!emptyContent && content ? (
              <div className="mb-2 font-regular">{content}</div>
            ) : null}

            {emptyContent && (
              <p className="mb-2 font-regular">{emptyContent}</p>
            )}

            <div className="flex flex-1 items-end">
              <Button
                variant="outline"
                onClick={onClick}
                className={cn(
                  "w-fit mt-3 py-2.5 rounded-lg text-sm border font-medium transition-all flex items-center justify-center gap-2",
                  color.buttonBackground && `bg-${color.buttonBackground}`,
                  color.buttonBorder
                    ? `border-${color.buttonBorder}`
                    : "border-primary",
                  color.buttonText && `text-${color.buttonText}`,
                  color.buttonBackgroundHover &&
                    `hover:bg-${color.buttonBackgroundHover}`,
                  color.buttonTextHover &&
                    `hover:text-${color.buttonTextHover}`,
                )}
              >
                {buttonText}
              </Button>
            </div>
          </div>
        </div>
      </Card>
    </CarouselItem>
  );
}
